'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Down;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
function Down(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#000' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-arrows-font-awesome-down ' + className,
      viewBox: '0 0 1792 1792',
      width: width,
      height: height },
    _react2.default.createElement('path', { fill: color, d: 'M1675 832q0 53-37 90l-651 652q-39 37-91 37-53 0-90-37l-651-652q-38-36-38-90 0-53 38-91l74-75q39-37 91-37 53 0 90 37l294 294v-704q0-52 38-90t90-38h128q52 0 90 38t38 90v704l294-294q37-37 90-37 52 0 91 37l75 75q37 39 37 91z' })
  );
}

Down.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Arrows/fontAwesome/Down/Down.js
// module id = 1090
// module chunks = 1